import { render, staticRenderFns } from "./TheProfileHeader.vue?vue&type=template&id=6a33a506&"
import script from "./TheProfileHeader.vue?vue&type=script&lang=ts&"
export * from "./TheProfileHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports